/**
 * How large load arrows and coordinate-system triads are drawn, relative to
 * the size the viewport picks for them. One multiplier covers both, because
 * the complaint they answer is "the annotations are the wrong size for this
 * model", not "arrows specifically".
 *
 * The engine is framework-free, so the value lives here as module state and
 * AnnotationScaleService owns persistence and the UI binding.
 */
export const ANNOTATION_SCALE_DEFAULT = 1;
export const ANNOTATION_SCALE_MIN = 0.25;
export const ANNOTATION_SCALE_MAX = 3;

let current: number = ANNOTATION_SCALE_DEFAULT;

/**
 * Anything unusable falls back to the default rather than shrinking to
 * nothing. Coercion is deliberately narrow: Number(null) and Number('') are
 * both 0, which would otherwise clamp to the minimum and read as a real
 * choice the user never made. A numeric string is accepted because that is
 * what a range input hands back.
 */
export function clampAnnotationScale(value: unknown): number {
  let n: number;
  if (typeof value === 'number') {
    n = value;
  } else if (typeof value === 'string' && value.trim() !== '') {
    n = Number(value);
  } else {
    return ANNOTATION_SCALE_DEFAULT;
  }
  if (!Number.isFinite(n)) return ANNOTATION_SCALE_DEFAULT;
  return Math.min(ANNOTATION_SCALE_MAX, Math.max(ANNOTATION_SCALE_MIN, n));
}

export function getAnnotationScale(): number {
  return current;
}

export function setAnnotationScale(value: unknown): number {
  current = clampAnnotationScale(value);
  return current;
}

export function resetAnnotationScale(): void {
  current = ANNOTATION_SCALE_DEFAULT;
}
